<template>
  <v-card width="428">
    <v-card-title class="primary--text pa-4">
      Edit user groups
    </v-card-title>
    <select-chips
      name="groups"
      @drop-item="handleDropChip(selectedUserGroups, $event, 'id')"
      v-model="selectedUserGroups"
      :items="listUserGroups"
      class="px-4"
      chips
      clearable
      :menu-props="{ bottom: true, offsetY: true }"
      multiple
      allow-overflow
      return-object
      item-text="name"
      item-value="id"
    />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="handleClose">Cancel</v-btn>
      <v-btn color="primary" data-test="applyUserGroups" :loading="isLoading" text @click="changeUserGroup"
        >Apply</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { onMounted, reactive, toRefs } from '@vue/composition-api';
import differenceBy from 'lodash.differenceby';

import useCommonModal from '@/compositions/useCommonModal';
import useUsers from '@/api/users';
import SelectChips from '@/components/SelectChips';

export default {
  name: 'ChangeUserGroups',
  components: { SelectChips },
  props: {
    id: {
      type: String,
      required: true
    },
    prevSelectedUserGroups: {
      type: Array,
      default: () => []
    },
    listUserGroups: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const modalComposition = useCommonModal();
    const { groups } = useUsers();

    const state = reactive({
      selectedUserGroups: [],
      isLoading: false
    });

    const handleClose = () => {
      modalComposition.modal.hide('ChangeUserGroups');
    };

    const handleDropChip = (array, id, typeOperation) => {
      if (typeOperation === 'id') {
        array.splice(
          array.findIndex(i => i.id === id),
          1
        );
      }
    };

    const changeUserGroup = async () => {
      state.isLoading = true;

      const promises = [];
      const needDeleteGroups = differenceBy(
        props.prevSelectedUserGroups,
        state.selectedUserGroups,
        'id'
      );
      const needAddGroups = differenceBy(
        state.selectedUserGroups,
        props.prevSelectedUserGroups,
        'id'
      );

      needAddGroups.forEach(item => {
        promises.push(
          groups.addToGroup({
            userGroupId: item.id,
            userId: props.id
          })
        );
      });

      needDeleteGroups.forEach(item => {
        promises.push(
          groups.remove({
            id: item.connectionId
          })
        );
      });

      await Promise.all(promises)
        .then(() => {
          handleClose();
        })
        .finally(() => {
          state.isLoading = false;
        });
    };

    onMounted(() => {
      state.selectedUserGroups = props.prevSelectedUserGroups.map(item => item);
    });

    return {
      ...toRefs(state),
      handleClose,
      changeUserGroup,
      handleDropChip
    };
  }
};
</script>
